import { Card, CardBody, CardHeader, CardProps, Flex, Grid, Heading } from "@chakra-ui/react";
import { createContext, ReactNode } from "react";
import React from "react";

export const WidgetBoxContext = createContext<boolean>(false);

export type WidgetBoxProps = CardProps & {
  title?: string;
  children: ReactNode;
};

const WidgetBox = ({ title, children, ...props }: WidgetBoxProps) => {
  let actions: ReactNode[] = [];
  let content: ReactNode[] = [];

  React.Children.forEach(children, child => {
    if ((child as any)?.type?.name === "WidgetBoxActions") {
      actions.push(child);
    } else {
      content.push(child);
    }
  });

  return (
    <WidgetBoxContext.Provider value={true}>
      <Card {...props}>
        {(title || actions.length > 0) && (
          <CardHeader pb={0}>
            <Grid templateColumns={title ? "1fr auto" : "auto"} alignItems="center" gap={2}>
              {title && <Heading size="md">{title}</Heading>}
              {actions.length > 0 && (
                <Grid
                  templateColumns={{ base: "1fr", md: "auto" }}
                  gap={2}
                  justifyItems={{ base: "stretch", md: "end" }}
                >
                  {actions}
                </Grid>
              )}
            </Grid>
          </CardHeader>
        )}
        <CardBody>{content}</CardBody>
      </Card>
    </WidgetBoxContext.Provider>
  );
};

export default WidgetBox;
